import React from 'react';
import PropTypes from 'prop-types';
import { extractDepartmentPayload } from '../../../../../helpers/companies';
import ActionsGroup from '../../../../common/ui/ItemActions';
import Validator from '../../../../common/forms/Validator';
import ErrorMessage from '../../../../common/forms/ErrorMessage';

export default class Department extends Validator {
  state = {
    ...this.props.department,
    isLoading: false,
    edit: false
  };

  validationRules = { name: { required: true } };

  _setDataLoaded = () => this.setState({ isLoading: false });

  handleChange = event => this.setState({ [event.target.name]: event.target.value });

  enterEditMode = () => this.setState({ edit: true });

  exitEditMode = () => {
    this.setState({ edit: false, isLoading: false, ...this.props.department });
    this._resetErrors();
  };

  saveAndExit = event => {
    event.preventDefault();

    if (this.validate(this.validationRules)) {
      this.setState({ isLoading: true });

      const { department: { id }, editDepartment } = this.props;

      editDepartment(id, extractDepartmentPayload(this.state))
        .then(this.exitEditMode);
    }
  };

  render () {
    const { department } = this.props;
    const { edit, isLoading, name } = this.state;

    return (
      <div className='list-group-item'>
        <form onSubmit={this.saveAndExit} className='d-flex justify-content-between align-items-center'>
          {edit ? (
            <input className='input mr-3' autoFocus value={name} onChange={this.handleChange} name='name' placeholder='Department name' />
          ) : (
            <span>{department.name}</span>
          )}

          <ActionsGroup isLoading={isLoading} isEditing={edit} exitEditMode={this.exitEditMode} enterEditMode={this.enterEditMode} />
        </form>

        <ErrorMessage errorText={this.validationErrors.name} />
      </div>
    );
  }
}

Department.propTypes = {
  department: PropTypes.object,
  editDepartment: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/app/companyDetails/Tabs/Departments/Department.js